import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import { LaIconEditorTab } from "^/Components/ScrivitoExtensions/LaIconEditorTab";
import HeadlineWidget from "../../Widgets/HeadlineWidget/HeadlineWidgetClass";
import SectionContentWidget from "../../Widgets/SectionContentWidget/SectionContentWidgetClass";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";
import {
  defaultPageInitialContent,
  defaultPageProperties,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("GlobalNewsOverviewPage", {
  title: "Global News Overview Page",
  hideInSelectionDialogs: true,
  attributes: localizeAttrList(
    [
      ...defaultPageProperties,
      ...metadataPropertiesGroup.properties,
      "isNavigationPage",
    ],
    "GlobalNewsOverviewPage"
  ),
  properties: [...defaultPageProperties, "isNavigationPage"],
  propertiesGroups: [
    {
      title: "LA Icon",
      component: ({ obj }) => (
        <LaIconEditorTab obj={obj} attribute="navigationIcon" />
      ),
      key: "laIconEditorTab",
    },
    socialCardsPropertiesGroup,
    metadataPropertiesGroup,
  ],
  initialContent: {
    body: [
      new SectionContentWidget({
        content: [new HeadlineWidget({ style: "h1" })],
      }),
    ],
    ...metadataInitialContent,
    ...defaultPageInitialContent,
    title: "Global News Overview Page",
  },
});
